import {
  CheckCircle,
  Close,
  Edit,
  KeyboardArrowDownRounded,
  KeyboardArrowUpRounded,
  Logout,
  PersonAdd,
  Settings,
  TaskAlt,
  Unpublished,
  Visibility,
  VisibilityOff,
} from "@mui/icons-material";
import PropTypes from "prop-types";
import {
  Card,
  FormControlLabel,
  FormGroup,
  Icon,
  Pagination,
  Stack,
  IconButton,
  Switch,
  Select,
  MenuItem,
  Menu,
  Tooltip,
  ListItemIcon,
  Divider,
  InputAdornment,
  Collapse,
} from "@mui/material";
import MDBadge from "components/MDBadge";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import SkLoading from "components/SkLoading";
import SkModal from "components/SkModal";
import { useMaterialUIController } from "context";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllOrders } from "redux/festures/orderSlice";
import { formattedDateServer } from "Utils/dateFunc";
import SingleOrderDetails from "./SingleOrder";
import MDInput from "components/MDInput";
import MDAvatar from "components/MDAvatar";
import { updateOrderDetails } from "redux/festures/orderSlice";
import { handleAlert } from "redux/festures/alertSlice";
import { useLocation } from "react-router-dom";
import { getSingleOrders } from "redux/festures/orderSlice";
import { SkPrice } from "Utils/dateFunc";
import CreateServiceOrder from "./CreateServiceOrder";
import AssignPartner from "./AssignPartner";
import SkConfirm from "components/SkComfirm";
import { handleModalStatus } from "redux/festures/orderSlice";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
import { getAllOrdersWithPageChange } from "redux/festures/orderSlice";
// import * as XLSX from "xlsx";
import { generatePDFWithAllOrderData } from "configs/SingleOrderConfig";
import { generateExcelWithAllOrderData } from "configs/SingleOrderExcellConfig";

const columns = {
  allLiveOrders: [
    { Header: "S.No", accessor: "no", width: "20px" },
    { Header: "Order Details", accessor: "order details" },
    { Header: "Order Status", accessor: "order status" },
    { Header: "Payment Method ", accessor: "payment method" },
    { Header: "Order Total", accessor: "order total" },
    { Header: "Place Order", accessor: "place Order" },
    // { Header: "Assign Partner", accessor: "assignPartner", alignItems: "center" },
    // { Header: "Update", accessor: "update" },
    { Header: "View", accessor: "view" },
    // { Header: "action", accessor: "action" },
  ],
  allOrders: [
    { Header: "S.No", accessor: "no", width: "20px" },
    { Header: "Order Details", accessor: "order details" },
    { Header: "Order Status", accessor: "order status" },
    { Header: "Payment Method ", accessor: "payment method" },
    { Header: "Order Total", accessor: "order total" },
    { Header: "Working Date", accessor: "place Order" },
    // { Header: "Assign Partner", accessor: "assignPartner", alignItems: "center" },
    // { Header: "Update", accessor: "update" },
    { Header: "View", accessor: "view" },
    // { Header: "action", accessor: "action" },
  ],
  allOrdersEcom: [
    { Header: "S.No", accessor: "no", width: "20px" },
    { Header: "Order Details", accessor: "order details" },
    { Header: "Order Status", accessor: "order status" },
    { Header: "Payment Method ", accessor: "payment method" },
    { Header: "Order Total", accessor: "order total" },
    { Header: "Place Order", accessor: "place Order" },
    // { Header: "Update", accessor: "update" },
    { Header: "View", accessor: "view" },
    // { Header: "action", accessor: "action" },
  ],
};

const mapStatusByName = {
  PENDING: "PENDING",
  ORDERED: "ORDERED",
  ACCEPTED: "ACCEPTED",
  ONTHEWAY: "ON THE WAY",
  WORKING: "WORKING",
  COMPLETED: "COMPLETED",
  CANCELLED: "CANCELLED",
  OUT_OF_DELIVERY: "OUT FOR DELIVERY",
  DELIVERED: "DELIVERED",
  RETURN_REQUEST: "RETURN REQUEST",
  RETURNED: "RETURNED",
  RETURN_REQUEST_APPROVED: "RETURN REQUEST APPROVED",
  CANCELLED: "CANCELLED",
  SHIPPED: "SHIPPED",
  MULTI_STATUS: "MULTI STATUS",
  UPCOMING: "UPCOMING",
};

//Static Filters

const dateFilter = [
  {
    _id: 0,
    name: "All Products",
  },
  {
    _id: "today",
    name: "Today",
  },
  {
    _id: "week",
    name: "This Week",
  },
  {
    _id: "month",
    name: "This Month",
  },
  {
    _id: "year",
    name: "This Year",
  },
  // {
  //   _id: 'manually',
  //   name: 'Manually'
  // },
];

const sortByPrice = [
  {
    _id: 0,
    name: "All",
  },
  {
    _id: "high_to_low",
    name: "High To Low",
  },
  {
    _id: "low_to_high",
    name: "Low To High",
  },
];

const filterByStatusService = [
  {
    _id: 0,
    name: "CHOOSE STATUS",
  },
  {
    _id: "PENDING",
    name: "PENDING",
  },
  {
    _id: "UPCOMING",
    name: "UPCOMING",
  },
  {
    _id: "COMPLETED",
    name: "COMPLETED",
  },
  {
    _id: "CANCELLED",
    name: "CANCELLED",
  },
];
const filterByStatusEcomm = [
  {
    _id: 0,
    name: "Choose Status",
  },
  {
    _id: "PENDING",
    name: "Pending",
  },
  {
    _id: "ORDERED",
    name: "Ordered",
  },
  {
    _id: "OUT_OF_DELIVERY",
    name: "Out For Delivery",
  },
  {
    _id: "DELIVERED",
    name: "Delivered",
  },
  {
    _id: "RETURN_REQUEST",
    name: "Return Request",
  },
  {
    _id: "RETURNED",
    name: "Returned",
  },
  {
    _id: "RETURN_REQUEST_APPROVED",
    name: "Return Request Approved",
  },
  {
    _id: "CANCELLED",
    name: "Cancelled",
  },
  {
    _id: "SHIPPED",
    name: "Shipped",
  },
  {
    _id: "MULTI_STATUS",
    name: "Multi Status",
  },
];

const filterByPaymentMethod = [
  {
    _id: 0,
    name: "Choose Payment Method",
  },
  {
    _id: "COD",
    name: "Cash On Delivery",
  },
  {
    _id: "ONLINE",
    name: "Online Transaction",
  },
  {
    _id: "WALLET",
    name: "Wallet",
  },
  {
    _id: "RAZORPAY",
    name: "Razorpay (Online)",
  },
];

const Orders = () => {
  const [allListData, setAllListData] = useState(null);
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const admin = localStorage.getItem("admin_id");
  const dispatch = useDispatch();
  const [rowsData, setRowsData] = useState([]);
  const [ecom, setEcom] = useState(false);
  const [isOpenDialog, setIsOpenDialog] = useState(false);
  const [isOpenDialog2, setIsOpenDialog2] = useState(false);
  const { pathname } = useLocation();
  const [filterCollapse, setFilterCollapse] = useState(false);
  const [createOrderModal, setCreateOrderModal] = useState(false);
  // const [isStatus, setIsStatus] = useState(null);

  const [viewOrderId, setViewOrderId] = useState(null);
  const [viewProductModal, setViewProductModal] = useState(false);
  const [assignPartnerModal, setAssignPartnerModal] = useState(false);
  const [singleOrder, setSingleOrder] = useState(false);
  ;
  const [pagess, setPagess] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const { AllOrders, Loading, isPages, isNewOrderId, isModalStatus } = useSelector((state) => ({
    ...state.isOrders,
  }));
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading2, setIsLoading2] = useState(false);
  const [refreshData, setRefreshData] = useState(0);
  

  useEffect(() => {
    if (pathname === "/orders/ecomm-orders") {
      setPagess(1);
      setEcom(true);
    } else {
      setPagess(1);
      setEcom(false);
    }
  }, [pathname]);

  useEffect(() => {
    if (isNewOrderId && isModalStatus) {
      setViewOrderId(isNewOrderId);
      setViewProductModal(isModalStatus);
    }
  }, [isNewOrderId, isModalStatus]);

  const [isOrderUpdate, setIsOrderUpdate] = useState("");
  const [filter, setFilter] = useState({
    filter: 0,
    status: 0,
    price: 0,
    paymentMethod: 0,
    search: "",
  });
  const [isOrderDetails, setIsOrderDetails] = useState(null);

  const isFindStatus = (isObject) => {
    let isStatusData = null;
    isObject?.items &&
      isObject?.items?.some((order) => {
        ;
        if (order?.status === isObject?.items?.at(0)?.status) {
          isStatusData = isObject?.items?.at(0)?.status;
        } else {
          isStatusData = "Multiple Status";
        }
      });
    return isStatusData;
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const [openMenu, setOpenMenu] = useState(false);

  const handleClick = ({ event }) => {
    setAnchorEl(event.currentTarget);
    ;
    ;
  };
  const handleOpenMenu = ({ event }) => {
    setOpenMenu(event.currentTarget);
  };
  const isStatusUpdateFunction = (isStatus, all) => {
    const status = ecom ? { status: isStatus } : { bookingStatus: isStatus };

    dispatch(
      updateOrderDetails({
        url: ecom
          ? all || !isOrderDetails?.productId
            ? `/eCommerce/updateAllProductStatus/${viewOrderId || isOrderDetails?._id}/${admin}`
            : `/eCommerce/updateSingleStatus/${viewOrderId || isOrderDetails?._id}/${admin}?productId=${isOrderDetails?.productId?._id || isOrderDetails?.productId}`
          : `/update-booking-status/${isOrderDetails?._id}/${admin}`,
        data: status,
        method: ecom ? "put" : "patch",
      })
    ).then((data) => {
      ;
      dispatch(
        handleAlert({
          isOpen: true,
          type: `${data?.payload?.success ? "success" : "error"}`,
          msg: `${data?.payload?.message}`,
        })
      );
      if (data?.payload?.success) {
        if (viewProductModal) {
          dispatch(
            getSingleOrders(
              ecom
                ? `/eCommerce/getByOrderId/${viewOrderId || isOrderDetails?._id}/${admin}`
                : `/get-booking/${viewOrderId || isOrderDetails?._id}/${admin}`
            )
          );
        }
        setRefreshData((prev) => prev + 1);
      }
    });
  };
  useEffect(() => {
    const params = new URLSearchParams();
    if (filter?.filter) params.append("filter", filter.filter);
    if (filter?.price) {
      if (ecom) {
        params.append("price", filter.price);
      } else {
        params.append(
          "sort",
          filter.price === "high_to_low" ? "high" : filter.price === "low_to_high" ? "low" : ""
        );
      }
    }
    if (filter?.paymentMethod) params.append("paymentMethod", filter.paymentMethod);
    if (filter?.status) params.append("status", filter.status);
    if (filter?.search) {
      params.append("search", filter.search);
      // Also send as name and orderId for potential specific backend handling
      params.append("fullName", filter.search);
      params.append("_id", filter.search);
    }
    params.append("page", pagess);
    params.append("limit", pageSize);
    if (!ecom) params.append("livestatus", "false");

    dispatch(
      getAllOrders(
        ecom
          ? `/eCommerce/filterOrderByDate/${admin}?${params.toString()}`
          : `/all-bookings/${admin}?${params.toString()}`
      )
    ).then((data) => {
      ;
      if (data.payload.success) {
        const temprows =
          data.payload?.data &&
          data.payload?.data?.at(0) &&
          data.payload?.data?.map((value, index) => {
            return ecom
              ? {
                  no: (
                    <MDTypography
                      sx={{ fontSize: 12, fontWeight: "medium", width: 10 }}
                      variant="text"
                    >
                      {(pagess - 1) * pageSize + index + 1}
                    </MDTypography>
                  ),
                  "order status": (
                    <>
                      <Tooltip title={value?.bookingStatus || "N/A"}>
                        <IconButton
                          aria-controls="notification-menu"
                          disabled={
                            value?.bookingStatus === "PENDING" ||
                            value?.bookingStatus === "CANCELLED" ||
                            value?.bookingStatus === "DELIVERED" ||
                            value?.bookingStatus === "RETURN_REQUEST" ||
                            value?.bookingStatus === "RETURN_REQUEST_APPROVED" ||
                            value?.bookingStatus === "MULTI_STATUS" ||
                            value?.bookingStatus === "RETURNED"
                          }
                          aria-haspopup="true"
                          component="a"
                          target="_blank"
                          rel="noreferrer"
                          variant="gradient"
                          color="info"
                          size="small"
                          circular
                          onClick={(e) => {
                            handleOpenMenu({ event: e });
                            setIsOrderDetails(value);
                          }}
                        >
                          <MDBadge
                            badgeContent={
                              value?.status
                                ? mapStatusByName[value?.status]
                                : value?.bookingStatus
                                  ? mapStatusByName[value?.bookingStatus]
                                  : "-"
                            }
                            color={
                              ((value?.status === "DELIVERED" ||
                                value?.bookingStatus === "DELIVERED") &&
                                "success") ||
                              ((value?.status === "CANCELLED" ||
                                value?.bookingStatus === "CANCELLED") &&
                                "error") ||
                              ((value?.status === "OUT_OF_DELIVERY" ||
                                value?.bookingStatus === "OUT_OF_DELIVERY") &&
                                "info") ||
                              ((value?.status === "RETURNED" ||
                                value?.bookingStatus === "RETURNED") &&
                                "error") ||
                              ((value?.status === "RETURN_REQUEST" ||
                                value?.bookingStatus === "RETURN_REQUEST") &&
                                "warning") ||
                              ((value?.status === "RETURN_REQUEST_APPROVED" ||
                                value?.bookingStatus === "RETURN_REQUEST_APPROVED") &&
                                "info") ||
                              ((value?.status === "ACCEPTED" ||
                                value?.bookingStatus === "ACCEPTED") &&
                                "success") ||
                              ((value?.status === "PENDING" ||
                                value?.bookingStatus === "PENDING") &&
                                "warning") ||
                              ((value?.status === "ORDERED" ||
                                value?.bookingStatus === "ORDERED") &&
                                "primary") ||
                              ((value?.status === "ONTHEWAY" ||
                                value?.bookingStatus === "ONTHEWAY") &&
                                "info") ||
                              ((value?.status === "WORKING" ||
                                value?.bookingStatus === "WORKING") &&
                                "secondary") ||
                              ((value?.status === "COMPLETED" ||
                                value?.bookingStatus === "COMPLETED") &&
                                "success") ||
                              ((value?.status === "SHIPPED" ||
                                value?.bookingStatus === "SHIPPED") &&
                                "secondary") ||
                              ((value?.status === "MULTI_STATUS" ||
                                value?.bookingStatus === "MULTI_STATUS") &&
                                "warning") ||
                              ((value?.status === "UPCOMING" ||
                                value?.bookingStatus === "UPCOMING") &&
                                "primary")
                            }
                            variant="gradient"
                            size="lg"
                          />
                        </IconButton>
                      </Tooltip>
                    </>
                  ),
                  "order details": (
                    <MDBox
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",

                        justifyContent: "flex-start",
                      }}
                    >
                      <MDTypography
                        sx={{ fontSize: 12, fontWeight: "medium" }}
                        variant="text"
                        style={{
                          maxWidth: "300px",
                          lineHeight: "20px",
                          display: "-webkit-box",
                          WebkitBoxOrient: "vertical",
                          WebkitLineClamp: 2,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        Name: {value?.customerId?.fullName || "-"}
                      </MDTypography>
                      {/* <MDTypography
                    sx={{ fontSize: 12, fontWeight: "medium" }}
                    variant="text"
                    style={{
                      maxWidth: "300px",
                      lineHeight: "20px",
                      display: "-webkit-box",
                      WebkitBoxOrient: "vertical",
                      WebkitLineClamp: 2,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    Email: {value?.address?.email || "N/A"}
                  </MDTypography> */}

                      <MDTypography sx={{ fontSize: 12, fontWeight: "medium" }} variant="text">
                        OrderId: {value?.orderId || "N/A"}
                      </MDTypography>
                      
                    </MDBox>
                  ),
                  // "order status": (
                  //   <MDBadge
                  //     badgeContent={value?.status ? mapStatusByName[value?.status] : "-"}
                  //     color={
                  //       (value?.status === "DELIVERED" && "success") ||
                  //       (value?.status === "CANCELLED" && "error") ||
                  //       (value?.status === "OUT_OF_DELIVERY" && "info") ||
                  //       (value?.status === "RETURNED" && "error") ||
                  //       (value?.status === "RETURN_REQUEST" && "warning") ||
                  //       (value?.status === "RETURN_REQUEST_APPROVED" && "info") ||
                  //       (value?.status === "ACCEPTED" && "success") ||
                  //       (value?.status === "PENDING" && "warning") ||
                  //       (value?.status === "ORDERED" && "primary") ||
                  //       (value?.status === "ONTHEWAY" && "info") ||
                  //       (value?.status === "WORKING" && "secondary") ||
                  //       (value?.status === "COMPLETED" && "success") ||
                  //       (value?.status === "SHIPPED" && "secondary") ||
                  //       (value?.status === "MULTI_STATUS" && "warning")
                  //     }
                  //     variant="gradient"
                  //     size="lg"
                  //   />
                  // ),
                  "payment method": (
                    <MDBox
                      sx={{
                        display: "flex",
                        // flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        // gap: 1,
                      }}
                    >
                      {(value?.paymentMethod === "COD" && (
                        <MDBadge badgeContent="COD" color="success" variant="gradient" size="lg" />
                      )) ||
                        (value?.paymentMethod === "ONLINE" && (
                          <MDBadge
                            badgeContent="ONLINE"
                            color="primary"
                            variant="gradient"
                            size="lg"
                          />
                        )) ||
                        (value?.paymentMethod === "PAYMENT_ACCEPTED_ADMIN" && (
                          <MDBadge
                            badgeContent="PAYMENT_ACCEPTED_ADMIN"
                            color="success"
                            variant="gradient"
                            size="lg"
                          />
                        )) ||
                        (value?.paymentMethod === "WALLET" && (
                          <MDBadge
                            badgeContent="Wallet"
                            color="info"
                            variant="gradient"
                            size="lg"
                          />
                        )) ||
                        (value?.paymentMethod === "RAZORPAY" && (
                          <MDBadge
                            badgeContent="ONLINE"
                            color="primary"
                            variant="gradient"
                            size="lg"
                          />
                        )) || (
                          <MDBadge badgeContent="N/A" color="error" variant="gradient" size="lg" />
                        )}
                    </MDBox>
                  ),
                  "order total": value?.orderTotal ? SkPrice(value?.orderTotal) : "-",
                  //   < MDBadge
                  //     badgeContent={ value?.orderTotal }
                  //     color="secondary"
                  //     variant="gradient"
                  //     size="lg"
                  // />
                  view: (
                    <IconButton
                      aria-label="action_edit"
                      onClick={() => {
                        setViewProductModal(true);
                        setViewOrderId(value?._id);
                      }}
                    >
                      <Visibility
                        sx={({ palette: { dark, white, info } }) => ({
                          color: darkMode ? info.main : dark.main,
                        })}
                      />
                    </IconButton>
                  ),
                  //   visibility: (
                  //     <Switch
                  //       value={value?.visibility}
                  //       checked={value?.visibility}
                  //       color={"info"}
                  //       onChange={(e) => handleChangeSwitch(value?._id)}
                  //       inputProps={{ "aria-label": "controlled" }}
                  //     />
                  //   ),
                  "place Order": (
                    <MDTypography sx={{ fontSize: 12, fontWeight: "medium" }} variant="text">
                      {formattedDateServer(new Date(value?.createdAt)) || "N/A"}
                    </MDTypography>
                  ),
                }
              : {
                  no: (
                    <MDTypography
                      sx={{ fontSize: 12, fontWeight: "medium", width: 10 }}
                      variant="text"
                    >
                      {(pagess - 1) * pageSize + index + 1}
                    </MDTypography>
                  ),
                  update: (
                    <>
                      <Tooltip title={value?.status || "N/A"}>
                        <IconButton
                          aria-controls="notification-menu"
                          disabled={
                            value?.status === "PENDING" ||
                            value?.status === "CANCELLED" ||
                            value?.status === "WORKING"
                          }
                          aria-haspopup="true"
                          component="a"
                          target="_blank"
                          rel="noreferrer"
                          variant="gradient"
                          color="info"
                          size="small"
                          circular
                          onClick={(e) => {
                            handleOpenMenu({ event: e });
                            setIsOrderDetails(value);
                          }}
                        >
                          <MDBadge
                            badgeContent="Update Status"
                            color="primary"
                            variant="gradient"
                            size="lg"
                          />
                        </IconButton>
                      </Tooltip>
                    </>
                  ),
                  "order details": (
                    <MDBox
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",

                        justifyContent: "flex-start",
                      }}
                    >
                      <MDTypography
                        sx={{ fontSize: 12, fontWeight: "medium" }}
                        variant="text"
                        style={{
                          maxWidth: "300px",
                          lineHeight: "20px",
                          display: "-webkit-box",
                          WebkitBoxOrient: "vertical",
                          WebkitLineClamp: 2,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        Name: {value?.userId?.fullName || "-"}
                      </MDTypography>
                      {/* <MDTypography
                    sx={{ fontSize: 12, fontWeight: "medium" }}
                    variant="text"
                    style={{
                      maxWidth: "300px",
                      lineHeight: "20px",
                      display: "-webkit-box",
                      WebkitBoxOrient: "vertical",
                      WebkitLineClamp: 2,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    Email: {value?.address?.email || "N/A"}
                  </MDTypography> */}

                      <MDTypography sx={{ fontSize: 12, fontWeight: "medium" }} variant="text">
                        OrderId: {value?._id || "N/A"}
                      </MDTypography>
                      
                    </MDBox>
                  ),
                  "order status": (
                    <Tooltip title={value?.bookingStatus || "N/A"}>
                      <IconButton
                        aria-controls="notification-menu"
                        // disabled={value?.status !== "ORDERED"}
                        aria-haspopup="true"
                        component="a"
                        target="_blank"
                        rel="noreferrer"
                        variant="gradient"
                        color="info"
                        size="small"
                        circular
                        onClick={(e) => {
                          handleOpenMenu({ event: e });
                          setIsOrderDetails(value);
                        }}
                      >
                        <MDBadge
                          badgeContent={
                            value?.bookingStatus ? mapStatusByName[value?.bookingStatus] : "-"
                          }
                          color={
                            (value?.bookingStatus === "DELIVERED" && "success") ||
                            (value?.bookingStatus === "CANCELLED" && "error") ||
                            (value?.bookingStatus === "OUT_OF_DELIVERY" && "info") ||
                            (value?.bookingStatus === "RETURNED" && "error") ||
                            (value?.bookingStatus === "RETURN_REQUEST" && "warning") ||
                            (value?.bookingStatus === "RETURN_REQUEST_APPROVED" && "info") ||
                            (value?.bookingStatus === "ACCEPTED" && "success") ||
                            (value?.bookingStatus === "PENDING" && "warning") ||
                            (value?.bookingStatus === "ORDERED" && "primary") ||
                            (value?.bookingStatus === "ONTHEWAY" && "info") ||
                            (value?.bookingStatus === "WORKING" && "secondary") ||
                            (value?.bookingStatus === "COMPLETED" && "success") ||
                            (value?.bookingStatus === "SHIPPED" && "secondary") ||
                            (value?.bookingStatus === "MULTI_STATUS" && "warning")
                          }
                          variant="gradient"
                          size="lg"
                        />
                      </IconButton>
                    </Tooltip>
                  ),
                  "payment method": (
                    <MDBox
                      sx={{
                        display: "flex",
                        // flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        // gap: 1,
                      }}
                    >
                      {(value?.paymentMethod === "COD" && (
                        <MDBadge badgeContent="COD" color="success" variant="gradient" size="lg" />
                      )) ||
                        (value?.paymentMethod === "ONLINE" && (
                          <MDBadge
                            badgeContent="ONLINE"
                            color="primary"
                            variant="gradient"
                            size="lg"
                          />
                        )) ||
                        (value?.paymentMethod === "PAYMENT_ACCEPTED_ADMIN" && (
                          <MDBadge
                            badgeContent="PAYMENT_ACCEPTED_ADMIN"
                            color="success"
                            variant="gradient"
                            size="lg"
                          />
                        )) ||
                        (value?.paymentMethod === "WALLET" && (
                          <MDBadge
                            badgeContent="Wallet"
                            color="info"
                            variant="gradient"
                            size="lg"
                          />
                        )) ||
                        (value?.paymentMethod === "RAZORPAY" && (
                          <MDBadge
                            badgeContent="ONLINE"
                            color="primary"
                            variant="gradient"
                            size="lg"
                          />
                        )) || (
                          <MDBadge badgeContent="N/A" color="error" variant="gradient" size="lg" />
                        )}
                    </MDBox>
                  ),
                  "order total": value?.finalPayableAmount
                    ? SkPrice(value?.finalPayableAmount)
                    : "-",
                  //   < MDBadge
                  //     badgeContent={ value?.orderTotal }
                  //     color="secondary"
                  //     variant="gradient"
                  //     size="lg"
                  // />
                  view: (
                    <IconButton
                      aria-label="action_edit"
                      onClick={() => {
                        setViewProductModal(true);
                        setViewOrderId(value?._id);
                      }}
                    >
                      <Visibility
                        sx={({ palette: { dark, white, info } }) => ({
                          color: darkMode ? info.main : dark.main,
                        })}
                      />
                    </IconButton>
                  ),
                  //   visibility: (
                  //     <Switch
                  //       value={value?.visibility}
                  //       checked={value?.visibility}
                  //       color={"info"}
                  //       onChange={(e) => handleChangeSwitch(value?._id)}
                  //       inputProps={{ "aria-label": "controlled" }}
                  //     />
                  //   ),
                  "place Order": (
                    <MDTypography sx={{ fontSize: 12, fontWeight: "medium" }} variant="text">
                      {new Date(value?.serviceDateTime).toLocaleDateString("en-GB", {
                        hour: "numeric",
                        hour12: true,
                        minute: "numeric",
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      }) || "N/A"}
                    </MDTypography>
                  ),
                  // assignPartner: (
                  //   <IconButton
                  //     aria-label="action_edit"
                  //     onClick={() => {
                  //       setAssignPartnerModal(true);
                  //       setViewOrderId(value?._id);
                  //     }}
                  //     // disabled={value?.status !== "ORDERED"}
                  //   >
                  //     
                  //     <PersonAdd
                  //       sx={({ palette: { dark, white, info } }) => ({
                  //         color: darkMode ? info.main : dark.main,
                  //         // opacity: value?.status !== "ORDERED" ? 0.3 : 1,
                  //       })}
                  //     />
                  //   </IconButton>
                  // ),
                };
          });
        setRowsData(temprows);
      } else {
        setRowsData([]);
      }
    });
  }, [ecom, filter, pagess, viewProductModal, assignPartnerModal, createOrderModal, refreshData]);

  // getting all data order list in one state of all pages

  // const fetchPageData = async (page) => {
  //   const response = await dispatch(
  //     getAllOrdersWithPageChange(
  //       ecom
  //         ? `/eCommerce/filterOrderByDate/${admin}?${
  //             filter?.filter ? `filter=${encodeURIComponent(filter?.filter)}` : ""
  //           }${filter?.price ? `&price=${encodeURIComponent(filter?.price)}` : ""}${
  //             filter?.paymentMethod
  //               ? `&paymentMethod=${encodeURIComponent(filter?.paymentMethod)}`
  //               : ""
  //           }${filter?.status ? `&status=${encodeURIComponent(filter?.status)}` : ""}${
  //             filter?.search ? `&search=${encodeURIComponent(filter?.search)}` : ""
  //           }&page=${encodeURIComponent(page)}`
  //         : `/all-bookings/${admin}?${
  //             filter?.filter ? `filter=${encodeURIComponent(filter?.filter)}` : ""
  //           }${filter?.price ? `&price=${encodeURIComponent(filter?.price)}` : ""}${
  //             filter?.paymentMethod
  //               ? `&paymentMethod=${encodeURIComponent(filter?.paymentMethod)}`
  //               : ""
  //           }${filter?.status ? `&status=${encodeURIComponent(filter?.status)}` : ""}${
  //             filter?.search ? `&search=${encodeURIComponent(filter?.search)}` : ""
  //           }&page=${encodeURIComponent(page)}&livestatus=${false}`
  //     )
  //   );
  //   return response?.payload?.data;
  // };

  return (
    <>
      {!ecom ? (
        <SkModal
          show={createOrderModal}
          unShow={setCreateOrderModal}
          width={{ sx: "100%", md: "55%", xl: "55%", sm: "100%" }}
          height={"auto"}
          padding={3}
          overflowY={true}
          maxHeight="90vh"
        >
          <CreateServiceOrder
            createOrderModal={createOrderModal}
            setCreateOrderModal={setCreateOrderModal}
          />
        </SkModal>
      ) : null}
      <AssignPartner
        show={assignPartnerModal}
        unshow={setAssignPartnerModal}
        orderId={viewOrderId}
        setOrderId={setViewOrderId}
      />
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox mb={2} />
        {/* <MDBox py={5}>
          <Card id="delete-account">
            <MDBox p={1.5} display="flex" justifyContent="space-between" alignItems="center">
              <MDButton
                variant="gradient"
                sx={({ palette: { dark, white, info } }) => ({
                  color: white.main,
                  backgroundColor: darkMode ? info.main : dark.main,
                  "&:hover": {
                    color: white.main,
                    backgroundColor: darkMode ? info.main : dark.main,
                  },
                })}
                onClick={() => {
                  // setIsOpen(true);
                }}
              >
                <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                &nbsp; Create Users
              </MDButton>
              <MDButton
                variant="gradient"
                sx={({ palette: { dark, white, info } }) => ({
                  color: white.main,
                  backgroundColor: darkMode ? info.main : dark.main,
                  "&:hover": {
                    color: white.main,
                    backgroundColor: darkMode ? info.main : dark.main,
                  },
                })}
                onClick={() => {
                  // setIsOpen2(true);
                }}
              >
                <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                &nbsp; Create subCategory
              </MDButton>
            </MDBox>{" "}
          </Card>
        </MDBox> */}
        <MDBox py={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <MDTypography variant="h6" color="white">
                Order &apos;s Table{" "}
              </MDTypography>
              <MDBox>
                {AllOrders && AllOrders?.length > 0 && (
                  <>
                    <MDButton
                      variant="gradient"
                      color="dark"
                      sx={({ palette: { dark, white, info } }) => ({
                        color: white.main,
                        backgroundColor: dark.main,
                        mr: 1,
                        "&:hover": {
                          color: white.main,
                          backgroundColor: dark.main,
                        },
                      })}
                      disabled={isLoading}
                      onClick={async () =>
                        await generatePDFWithAllOrderData({
                          loading: setIsLoading,
                          totalPages: isPages,
                          ecom: ecom,
                          url: ecom
                            ? `/eCommerce/filterOrderByDate/${admin}?${(() => {
                                const params = new URLSearchParams();
                                if (filter?.filter) params.append("filter", filter.filter);
                                if (filter?.price) params.append("price", filter.price);
                                if (filter?.paymentMethod)
                                  params.append("paymentMethod", filter.paymentMethod);
                                if (filter?.status) params.append("status", filter.status);
                                if (filter?.search) {
                                  params.append("search", filter.search);
                                  params.append("fullName", filter.search);
                                  params.append("_id", filter.search);
                                }
                                return params.toString();
                              })()}`
                            : `/all-bookings/${admin}?${(() => {
                                const params = new URLSearchParams();
                                if (filter?.filter) params.append("filter", filter.filter);
                                if (filter?.price) params.append("sort", filter.price === "high_to_low" ? "high" : filter.price === "low_to_high" ? "low" : "");
                                if (filter?.paymentMethod)
                                  params.append("paymentMethod", filter.paymentMethod);
                                if (filter?.status) params.append("status", filter.status);
                                if (filter?.search) {
                                  params.append("search", filter.search);
                                  params.append("fullName", filter.search);
                                  params.append("_id", filter.search);
                                }
                                return params.toString();
                              })()}&livestatus=false`,
                        })
                      }
                    >
                      {isLoading ? (
                        "loading..."
                      ) : (
                        <>
                          <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                          &nbsp; Export PDF
                        </>
                      )}
                    </MDButton>
                    <MDButton
                      disabled={isLoading2}
                      variant="gradient"
                      color="dark"
                      sx={({ palette: { dark, white, info } }) => ({
                        color: white.main,
                        backgroundColor: dark.main,
                        mr: 1,
                        "&:hover": {
                          color: white.main,
                          backgroundColor: dark.main,
                        },
                      })}
                      onClick={() =>
                        generateExcelWithAllOrderData({
                          loading: setIsLoading2,
                          totalPages: isPages,
                          ecom: ecom,
                          url: ecom
                            ? `/eCommerce/filterOrderByDate/${admin}?${(() => {
                                const params = new URLSearchParams();
                                if (filter?.filter) params.append("filter", filter.filter);
                                if (filter?.price) params.append("price", filter.price);
                                if (filter?.paymentMethod)
                                  params.append("paymentMethod", filter.paymentMethod);
                                if (filter?.status) params.append("status", filter.status);
                                if (filter?.search) {
                                  params.append("search", filter.search);
                                  params.append("fullName", filter.search);
                                  params.append("_id", filter.search);
                                }
                                return params.toString();
                              })()}`
                            : `/all-bookings/${admin}?${(() => {
                                const params = new URLSearchParams();
                                if (filter?.filter) params.append("filter", filter.filter);
                                if (filter?.price) params.append("sort", filter.price === "high_to_low" ? "high" : filter.price === "low_to_high" ? "low" : "");
                                if (filter?.paymentMethod)
                                  params.append("paymentMethod", filter.paymentMethod);
                                if (filter?.status) params.append("status", filter.status);
                                if (filter?.search) {
                                  params.append("search", filter.search);
                                  params.append("fullName", filter.search);
                                  params.append("_id", filter.search);
                                }
                                return params.toString();
                              })()}&livestatus=false`,
                        })
                      }
                    >
                      {isLoading2 ? (
                        "loading..."
                      ) : (
                        <>
                          <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                          &nbsp; Export Excel
                        </>
                      )}
                    </MDButton>
                  </>
                )}
                {/* {!ecom ? (
                  <MDButton
                    variant="gradient"
                    color="dark"
                    sx={({ palette: { dark, white, info } }) => ({
                      color: white.main,
                      backgroundColor: dark.main,
                      "&:hover": {
                        color: white.main,
                        backgroundColor: dark.main,
                      },
                    })}
                    onClick={() => {
                      setCreateOrderModal(true);
                      // setUpdateProductModal(false);
                    }}
                  >
                    <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                    &nbsp; Create Order
                  </MDButton>
                ) : null} */}
              </MDBox>
            </MDBox>
            <MDBox
              // px={3}
              sx={({ palette: { dark, white, info }, breakpoints }) => ({
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                flexDirection: "column",
                width: "100%",
                gap: 0.5,
                [breakpoints.up("xs")]: {
                  flexDirection: "column",
                },
                [breakpoints.up("sm")]: {
                  flexDirection: "column",
                },
                [breakpoints.up("md")]: {
                  flexDirection: "column",
                },
                [breakpoints.up("lg")]: {
                  flexDirection: "column",
                },
              })}
            >
              {/* <MDBox
            py={3}
            sx={{
              flexDirection: "column",
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              gap: 1.5,
              width: "50%",
            }}
          >
            <MDTypography variant="button"> Product Filter</MDTypography>
            <Select
              labelId="demo-select-small-label"
              id="demo-select-small"
              value={isFilterName}
              onChange={(e) => {
                setIsFilterName(e.target.value);
                setPagess(1);
                setFilter(tabsName && tabsName[0]);
                setIsSearch("");
              }}
              sx={({ palette: { dark, white, info } }) => ({
                width: '100%',
                height: "3rem",
                color: darkMode ? white?.main : dark?.main,
                bgcolor: "transparent",
                "&	.MuiSelect-icon": {
                  color: darkMode ? white?.main : dark?.main,
                  display: "block !important",
                  fontSize: "1.5rem !important",
                },
              })}
            >
              <MenuItem value={"name"}>Name</MenuItem>
              <MenuItem value={"productId"}>ProductId</MenuItem>
            </Select>
          </MDBox> */}
              <MDBox
                sx={({ palette: { dark, white, info }, breakpoints }) => ({
                  [breakpoints.up("xs")]: {
                    flexDirection: "column",
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    gap: 1.5,
                    pl: 3,
                  },
                  [breakpoints.up("sm")]: {
                    flexDirection: "column",
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    gap: 1.5,
                    pl: 3,
                  },
                  [breakpoints.up("md")]: {
                    flexDirection: "column",
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    gap: 1.5,
                    pt: 4,
                  },
                  [breakpoints.up("lg")]: {
                    flexDirection: "column",
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    gap: 1.5,
                    pt: 4,
                  },
                })}
              >
                <MDTypography variant="button">Order Filter</MDTypography>

                <MDInput
                  placeholder="UserName, OrderID..."
                  type="text"
                  fullWidth
                  name="sarch here"
                  value={filter?.search}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment
                        position="end"
                        sx={({ palette: { dark, white, info } }) => ({
                          backgroundColor: darkMode ? white.main : dark.main,
                          height: "100%",
                          padding: "1rem",
                          borderRadius: "5px",
                        })}
                      >
                        {filterCollapse ? (
                          <KeyboardArrowUpRounded
                            onClick={() => setFilterCollapse(false)}
                            size="20"
                            sx={({ palette: { dark, white, info } }) => ({
                              color: !darkMode ? white.main : dark.main,
                              cursor: "pointer",
                            })}
                          />
                        ) : (
                          <KeyboardArrowDownRounded
                            onClick={() => setFilterCollapse(true)}
                            size="20"
                            sx={({ palette: { dark, white, info } }) => ({
                              color: !darkMode ? white.main : dark.main,
                              cursor: "pointer",
                            })}
                          />
                        )}
                      </InputAdornment>
                    ),
                  }}
                  onChange={(e) => {
                    setPagess(1);
                    setFilter((prev) => ({
                      ...prev,
                      search: e.target.value,
                    }));
                  }}
                />
              </MDBox>
              <Collapse
                in={filterCollapse}
                timeout="auto"
                unmountOnExit
                sx={{ width: "100%", p: 3 }}
              >
                <MDBox
                  sx={({ palette: { dark, white, info }, breakpoints }) => ({
                    display: "flex",
                    width: "100%",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "2%",
                    width: "100%",
                    [breakpoints.up("xs")]: {
                      flexDirection: "column",
                      justifyContent: "flex-start",
                      alignItems: "flex-start",
                    },
                    [breakpoints.up("sm")]: {
                      flexDirection: "column",
                      justifyContent: "flex-start",
                      alignItems: "flex-start",
                    },
                    [breakpoints.up("md")]: {
                      flexDirection: "row",
                      flexWrap: "wrap",
                    },
                    [breakpoints.up("lg")]: {
                      flexDirection: "row",
                      flexWrap: "wrap",
                    },
                  })}
                >
                  <MDBox width="23%" display="flex" flexDirection="column">
                    <MDTypography variant="button">Filter By Duration</MDTypography>
                    <Select
                      labelId="demo-select-small-label"
                      id="demo-select-small"
                      value={filter?.filter}
                      onChange={(e) => {
                        setPagess(1);
                        setFilter((prev) => ({
                          ...prev,
                          filter: e.target.value,
                        }));
                      }}
                      sx={({ palette: { dark, white, info } }) => ({
                        width: "100%",
                        height: "3rem",
                        color: darkMode ? white?.main : dark?.main,
                        bgcolor: "transparent",
                        "&	.MuiSelect-icon": {
                          color: darkMode ? white?.main : dark?.main,
                          display: "block !important",
                          fontSize: "1.5rem !important",
                        },
                      })}
                    >
                      {dateFilter?.map((ele, i) => (
                        <MenuItem component="option" key={i} value={ele?._id}>
                          {ele?.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </MDBox>
                  <MDBox width="23%" display="flex" flexDirection="column">
                    <MDTypography variant="button">Filter By Status</MDTypography>
                    <Select
                      labelId="demo-select-small-label"
                      id="demo-select-small"
                      value={filter?.status}
                      onChange={(e) => {
                        setPagess(1);
                        setFilter((prev) => ({
                          ...prev,
                          status: e.target.value,
                        }));
                      }}
                      sx={({ palette: { dark, white, info } }) => ({
                        width: "100%",
                        height: "3rem",
                        color: darkMode ? white?.main : dark?.main,
                        bgcolor: "transparent",
                        "&	.MuiSelect-icon": {
                          color: darkMode ? white?.main : dark?.main,
                          display: "block !important",
                          fontSize: "1.5rem !important",
                        },
                      })}
                    >
                      {!ecom
                        ? filterByStatusService?.map((ele, i) => (
                            <MenuItem key={i} value={ele?._id}>
                              {ele?.name}
                            </MenuItem>
                          ))
                        : filterByStatusEcomm?.map((ele, i) => (
                            <MenuItem key={i} value={ele?._id}>
                              {ele?.name}
                            </MenuItem>
                          ))}
                    </Select>
                  </MDBox>
                  <MDBox width="23%" display="flex" flexDirection="column">
                    <MDTypography variant="button">Sort By Price</MDTypography>
                    <Select
                      labelId="demo-select-small-label"
                      id="demo-select-small"
                      value={filter?.price}
                      onChange={(e) => {
                        setPagess(1);
                        setFilter((prev) => ({
                          ...prev,
                          price: e.target.value,
                        }));
                      }}
                      sx={({ palette: { dark, white, info } }) => ({
                        width: "100%",
                        height: "3rem",
                        color: darkMode ? white?.main : dark?.main,
                        bgcolor: "transparent",
                        "&	.MuiSelect-icon": {
                          color: darkMode ? white?.main : dark?.main,
                          display: "block !important",
                          fontSize: "1.5rem !important",
                        },
                      })}
                    >
                      {sortByPrice?.map((ele, i) => (
                        <MenuItem key={i} value={ele?._id}>
                          {ele?.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </MDBox>
                  <MDBox width="23%" display="flex" flexDirection="column">
                    <MDTypography variant="button">Filter By Payment Method</MDTypography>
                    <Select
                      labelId="demo-select-small-label"
                      id="demo-select-small"
                      value={filter?.paymentMethod}
                      onChange={(e) => {
                        setPagess(1);
                        setFilter((prev) => ({
                          ...prev,
                          paymentMethod: e.target.value,
                        }));
                      }}
                      sx={({ palette: { dark, white, info } }) => ({
                        width: "100%",
                        height: "3rem",
                        color: darkMode ? white?.main : dark?.main,
                        bgcolor: "transparent",
                        "&	.MuiSelect-icon": {
                          color: darkMode ? white?.main : dark?.main,
                          display: "block !important",
                          fontSize: "1.5rem !important",
                        },
                      })}
                    >
                      {filterByPaymentMethod?.map((ele, i) => (
                        <MenuItem key={i} value={ele?._id}>
                          {ele?.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </MDBox>
                </MDBox>
              </Collapse>
            </MDBox>
            <MDBox py={3}>
              {Loading ? (
                <SkLoading />
              ) : AllOrders && AllOrders.length > 0 ? (
                <>
                  {null}
                  <DataTable
                    table={{
                      columns: ecom ? columns.allOrdersEcom : columns?.allOrders,
                      rows: rowsData || [],
                    }}
                    isSorted={false}
                    entriesPerPage={{ defaultValue: pageSize, entries: [10, 20] }}
                    onEntriesPerPageChange={(value) => {
                      setPageSize(value);
                      setPagess(1);
                    }}
                    canSearch={false}
                    pagination={false} // ✅ using external server-side pagination
                    showTotalEntries={true}
                    noEndBorder
                  />

                  <MDBox
                    sx={{
                      mt: 5,
                      // minHeigth: "100vh",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Stack spacing={2} direction={"row"}>
                      <Pagination
                        sx={({ palette: { dark, white, info } }) => ({
                          "&.MuiPaginationItem-text": {
                            color: darkMode ? white.main : dark.main,
                          },
                          "&	.MuiPaginationItem-icon": {
                            color: darkMode ? white.main : dark.main,
                          },
                          "&		.MuiPaginationItem-textInfo": {
                            color: darkMode ? white.main : dark.main,
                          },
                        })}
                        color="info"
                        variant="text"
                        count={isPages}
                        page={pagess}
                        onChange={(e, value) => setPagess(value)}
                      />
                    </Stack>
                  </MDBox>
                </>
              ) : (
                <MDBox
                  // key={index}
                  display="flex"
                  justifyContent="center"
                  gap={2}
                  alignItems="center"
                  // width={"100%"}
                >
                  <MDTypography variant="h5"> Order Not Found ... !</MDTypography>
                </MDBox>
              )}
            </MDBox>
          </Card>
        </MDBox>
        <Footer />
      </DashboardLayout>
      <SkModal
        show={viewProductModal}
        unShow={setViewProductModal}
        width={{ sx: "100%", md: "75%", xl: "75%", sm: "100%" }}
        height={"80%"}
        padding={3}
        overflowY={true}
      >
        <SingleOrderDetails
          viewOrderId={viewOrderId}
          setViewProductModal={setViewProductModal}
          isFindStatus={isFindStatus}
          isOrder={isOrderDetails}
          setIsOrder={setIsOrderDetails}
          handleMenuOpen={handleOpenMenu}
          ecom={ecom}
          setIsOpenDialog2={setIsOpenDialog2}
          isOpenDialog2={isOpenDialog2}
          setSingleOrder={setSingleOrder}
          singleOrder={singleOrder}
          refreshOrders={() => setRefreshData((prev) => prev + 1)}
        />
      </SkModal>
      <Menu
        anchorEl={openMenu}
        anchorReference={null}
        MenuListProps={{
          "aria-labelledby": "fade-button",
        }}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        open={Boolean(openMenu)}
        onClose={() => setOpenMenu(false)}
      >
        {ecom ? (
          <>
            {(isOrderDetails?.orderDetails && isOrderDetails?.orderDetails?.status === "PENDING") ||
            isOrderDetails?.status === "PENDING" ? (
              <>
                <MenuItem
                  sx={{ border: "1px solid blue", mb: 1 }}
                  onClick={() => {
                    setOpenMenu(false);
                    isStatusUpdateFunction("ORDERED", true);
                  }}
                >
                  Ordered
                </MenuItem>
                {/* <MenuItem
                  sx={{ border: "1px solid blue", mb: 1 }}
                  onClick={() => {
                    setOpenMenu(false);
                    isStatusUpdateFunction("ACCEPTED", true);
                  }}
                >
                  Accepted
                </MenuItem> */}
                <MenuItem
                  sx={{ border: "1px solid blue", mb: 1 }}
                  onClick={() => {
                    setOpenMenu(false);
                    if (singleOrder) {
                      setIsOpenDialog2((Preview) => ({
                        ...Preview,
                        open: true,
                        isId: null,
                      }));
                    } else {
                      setIsOpenDialog((Preview) => ({
                        ...Preview,
                        open: true,
                        isId: null,
                      }));
                    }
                  }}
                >
                  Cancel
                </MenuItem>
              </>
            ) : null}

            {(isOrderDetails?.orderDetails &&
              isOrderDetails?.orderDetails?.status === "ORDERED") ||
            isOrderDetails?.status === "ORDERED" ? (
              <>
                <MenuItem
                  sx={{ border: "1px solid blue", mb: 1 }}
                  onClick={() => {
                    setOpenMenu(false);
                    isStatusUpdateFunction("SHIPPED", true);
                  }}
                >
                  {/* <MDAvatar size="sm">
                    <CheckCircle />
                  </MDAvatar>{" "} */}
                  Shipped
                </MenuItem>
                {singleOrder && (
                  <MenuItem
                    sx={{ border: "1px solid blue", mb: 1 }}
                    onClick={() => {
                      setOpenMenu(false);
                      setIsOpenDialog2((Preview) => ({
                        ...Preview,
                        open: true,
                        isId: null,
                      }));
                    }}
                  >
                    {/* <MDAvatar size="sm">
            <CheckCircle />
          </MDAvatar>{" "} */}
                    Cancel
                  </MenuItem>
                )}

                {!singleOrder && (
                  <MenuItem
                    sx={{ border: "1px solid blue", mb: 1 }}
                    onClick={() => {
                      setOpenMenu(false);
                      setIsOpenDialog((Preview) => ({
                        ...Preview,
                        open: true,
                        isId: null,
                      }));
                    }}
                  >
                    {/* <MDAvatar size="sm">
                    <Unpublished sx={{ fontSize: "2rem" }} />
                  </MDAvatar> */}
                    Cancel
                  </MenuItem>
                )}
              </>
            ) : null}
            {(isOrderDetails?.orderDetails && isOrderDetails?.orderDetails?.status === "SHIPPED") ||
            isOrderDetails?.status === "SHIPPED" ? (
              <>
                <MenuItem
                  sx={{ border: "1px solid blue", mb: 1 }}
                  onClick={() => {
                    setOpenMenu(false);
                    isStatusUpdateFunction("OUT_OF_DELIVERY", true);
                  }}
                >
                  {/* <MDAvatar size="sm">
                    <CheckCircle />
                  </MDAvatar>{" "} */}
                  Out For Delivery
                </MenuItem>
                {singleOrder && (
                  <MenuItem
                    sx={{ border: "1px solid blue", mb: 1 }}
                    onClick={() => {
                      setOpenMenu(false);
                      setIsOpenDialog2((Preview) => ({
                        ...Preview,
                        open: true,
                        isId: null,
                      }));
                    }}
                  >
                    {/* <MDAvatar size="sm">
            <CheckCircle />
          </MDAvatar>{" "} */}
                    Cancel
                  </MenuItem>
                )}

                {!singleOrder && (
                  <MenuItem
                    sx={{ border: "1px solid blue", mb: 1 }}
                    onClick={() => {
                      setOpenMenu(false);
                      setIsOpenDialog((Preview) => ({
                        ...Preview,
                        open: true,
                        isId: null,
                      }));
                    }}
                  >
                    {/* <MDAvatar size="sm">
                    <Unpublished sx={{ fontSize: "2rem" }} />
                  </MDAvatar> */}
                    Cancel
                  </MenuItem>
                )}
              </>
            ) : null}
            {(isOrderDetails?.orderDetails &&
              isOrderDetails?.orderDetails?.status === "OUT_OF_DELIVERY") ||
            isOrderDetails?.status === "OUT_OF_DELIVERY" ? (
              <>
                <MenuItem
                  sx={{ border: "1px solid blue", mb: 1 }}
                  onClick={() => {
                    setOpenMenu(false);
                    isStatusUpdateFunction("DELIVERED", true);
                  }}
                >
                  {/* <MDAvatar size="sm">
                    <CheckCircle />
                  </MDAvatar>{" "} */}
                  Delivered
                </MenuItem>
                {singleOrder && (
                  <MenuItem
                    sx={{ border: "1px solid blue", mb: 1 }}
                    onClick={() => {
                      setOpenMenu(false);
                      setIsOpenDialog2((Preview) => ({
                        ...Preview,
                        open: true,
                        isId: null,
                      }));
                    }}
                  >
                    {/* <MDAvatar size="sm">
            <CheckCircle />
          </MDAvatar>{" "} */}
                    Cancel
                  </MenuItem>
                )}

                {!singleOrder && (
                  <MenuItem
                    sx={{ border: "1px solid blue", mb: 1 }}
                    onClick={() => {
                      setOpenMenu(false);
                      setIsOpenDialog((Preview) => ({
                        ...Preview,
                        open: true,
                        isId: null,
                      }));
                    }}
                  >
                    {/* <MDAvatar size="sm">
                    <Unpublished sx={{ fontSize: "2rem" }} />
                  </MDAvatar> */}
                    Cancel
                  </MenuItem>
                )}
              </>
            ) : null}
            {(isOrderDetails?.orderDetails &&
              isOrderDetails?.orderDetails?.status === "RETURN_REQUEST") ||
            isOrderDetails?.status === "RETURN_REQUEST" ? (
              <>
                <MenuItem
                  sx={{ border: "1px solid blue", mb: 1 }}
                  onClick={() => {
                    setOpenMenu(false);
                    isStatusUpdateFunction("RETURN_REQUEST_APPROVED");
                  }}
                >
                  {/* <MDAvatar size="sm">
                    <CheckCircle />
                  </MDAvatar>{" "} */}
                  Approve Return Request
                </MenuItem>

                {singleOrder && (
                  <MenuItem
                    sx={{ border: "1px solid blue", mb: 1 }}
                    onClick={() => {
                      setOpenMenu(false);
                      setIsOpenDialog2((Preview) => ({
                        ...Preview,
                        open: true,
                        isId: null,
                      }));
                    }}
                  >
                    {/* <MDAvatar size="sm">
            <CheckCircle />
          </MDAvatar>{" "} */}
                    Cancel
                  </MenuItem>
                )}

                {!singleOrder && (
                  <MenuItem
                    sx={{ border: "1px solid blue", mb: 1 }}
                    onClick={() => {
                      setOpenMenu(false);
                      setIsOpenDialog((Preview) => ({
                        ...Preview,
                        open: true,
                        isId: null,
                      }));
                    }}
                  >
                    {/* <MDAvatar size="sm">
                    <Unpublished sx={{ fontSize: "2rem" }} />
                  </MDAvatar> */}
                    Cancel
                  </MenuItem>
                )}
              </>
            ) : null}
            {(isOrderDetails?.orderDetails &&
              isOrderDetails?.orderDetails?.status === "RETURN_REQUEST_APPROVED") ||
            isOrderDetails?.status === "RETURN_REQUEST_APPROVED" ? (
              <>
                <MenuItem
                  sx={{ border: "1px solid blue", mb: 1 }}
                  onClick={() => {
                    setOpenMenu(false);
                    isStatusUpdateFunction("RETURNED");
                  }}
                >
                  {/* <MDAvatar size="sm">
                    <CheckCircle />
                  </MDAvatar>{" "} */}
                  Returned
                </MenuItem>
              </>
            ) : null}
          </>
        ) : (
          <>
            {isOrderDetails?.bookingStatus === "PENDING" || isOrderDetails?.status === "PENDING" ? (
              <>
                <MenuItem
                  sx={{ border: "1px solid blue", mb: 1 }}
                  onClick={() => {
                    setOpenMenu(false);
                    isStatusUpdateFunction("UPCOMING", true);
                  }}
                >
                  Upcoming
                </MenuItem>
                <MenuItem
                  sx={{ border: "1px solid blue", mb: 1 }}
                  onClick={() => {
                    setOpenMenu(false);
                    setIsOpenDialog((Preview) => ({
                      ...Preview,
                      open: true,
                      isId: null,
                    }));
                  }}
                >
                  Cancel
                </MenuItem>
              </>
            ) : null}
            {isOrderDetails?.bookingStatus === "UPCOMING" ||
            isOrderDetails?.status === "UPCOMING" ? (
              <>
                <MenuItem
                  sx={{ border: "1px solid blue", mb: 1 }}
                  onClick={() => {
                    setOpenMenu(false);
                    isStatusUpdateFunction("COMPLETED", true);
                  }}
                >
                  Completed
                </MenuItem>
                <MenuItem
                  sx={{ border: "1px solid blue", mb: 1 }}
                  onClick={() => {
                    setOpenMenu(false);
                    setIsOpenDialog((Preview) => ({
                      ...Preview,
                      open: true,
                      isId: null,
                    }));
                  }}
                >
                  Cancel
                </MenuItem>
              </>
            ) : null}
          </>
        )}
      </Menu>
      <SkConfirm
        dialogTitle={"Order Cancel"}
        dialogContent={"Are you sure you want to Cancel this Order?"}
        open={isOpenDialog}
        setOpen={setIsOpenDialog}
        rate={true}
        dialogAction={
          <MDBox
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 3,

              px: 3,
            }}
          >
            <MDButton
              variant="gradient"
              color="info"
              sx={{ width: "50%" }}
              onClick={() => {
                setIsOpenDialog((Preview) => ({
                  ...Preview,
                  open: false,
                  isId: null,
                }));
              }}
            >
              Cancel
            </MDButton>
            <MDButton
              variant="gradient"
              sx={{ width: "50%" }}
              color="error"
              onClick={() => {
                isStatusUpdateFunction("CANCELLED", true);

                setIsOpenDialog((Preview) => ({
                  ...Preview,
                  open: false,
                  isId: null,
                }));
              }}
            >
              yes
            </MDButton>
          </MDBox>
        }
      />
    </>
  );
};

export default Orders;
